import axios, { AxiosRequestConfig, AxiosResponse } from "axios"
import { API_URL } from "@/constants/endpoints"
import { HttpMethods } from "@/constants/globals"
import { Token } from "@/types/index"

export enum Header {
   TENANT_ID = "X-Tenant-ID",
   CUSTOMER_ID = "X-Customer-ID",
   FACILITY_ID = "X-Facility-ID",
}
export interface ApiResponse<T> extends AxiosResponse<T> {
   data: T
}

export interface ApiError {
   status: number
   message: string
}

const api = axios.create({
   baseURL: API_URL,
})

api.interceptors.request.use(
   (config) => {
      const token = localStorage.getItem(Token.AUTH_TOKEN)
      if (token) {
         config.headers = config.headers || {}
         config.headers["Authorization"] = `Token ${token}`
      }
      return config
   },
   (error) => {
      return Promise.reject(error)
   }
)

export const createApiRequest = async <T>(
   url: string,
   method: HttpMethods,
   data?: T,
   config?: AxiosRequestConfig
) => {
   const response = await api({
      url,
      method,
      headers: {
         "Content-Type": "application/json",
         Accept: "application/json",
      },
      data,
      ...config,
   })
   return response
}

export const headerStorageItemPairs = [
   { header: Header.TENANT_ID, item: Token.TENANT_ID },
   { header: Header.CUSTOMER_ID, item: Token.CUSTOMER_ID },
   { header: Header.FACILITY_ID, item: Token.FACILITY_ID },
]

export const getHeaderFromSessionStorage = (header: Header) => {
   const itemName = headerStorageItemPairs.find(
      (pair) => pair.header === header
   )?.item as string
   const value = sessionStorage.getItem(itemName)
   return {
      headers: {
         [header]: value,
      },
   }
}
